import React, { useEffect, useState } from "react";
import { getUser } from "@/lib/api";
import api from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { Terminal, Plus, Trash2 } from "lucide-react";

// Terminals: per-store multi-terminal setup. Only the store's own manager can
// add — enforced by the backend too.
export default function POSTerminals() {
  const u = getUser();
  const [rows, setRows] = useState([]);
  const [code, setCode] = useState("");
  const [name, setName] = useState("");

  const load = () => api.get("/pos/terminals").then((r) => setRows(r.data || []));
  useEffect(() => { load(); }, []);

  const add = async () => {
    if (!code.trim() || !name.trim()) return toast.error("Code + name required");
    try {
      await api.post("/pos/terminals", {
        store_id: u.location_id, store_type: u.department,
        code: code.trim(), name: name.trim(), is_active: true,
      });
      toast.success("Terminal added");
      setCode(""); setName(""); load();
    } catch (e) { toast.error(e?.response?.data?.detail || "Failed"); }
  };
  const remove = async (t) => {
    if (!window.confirm(`Deactivate ${t.code}?`)) return;
    await api.delete(`/pos/terminals/${t.id}`); load();
  };

  return (
    <div className="p-4 space-y-4 max-w-5xl mx-auto">
      <div className="bg-white rounded-lg border border-slate-200 p-5">
        <div className="flex items-center gap-2 mb-3">
          <Terminal className="h-5 w-5 text-red-600" />
          <h2 className="text-lg font-semibold">Billing Terminals</h2>
        </div>
        <p className="text-xs text-slate-500 mb-3">Each cash register is opened per terminal. Add as many billing counters as your store needs.</p>
        <div className="flex gap-2 items-end">
          <label className="text-xs"><span className="text-[11px] uppercase tracking-widest text-slate-500 block mb-1">Code *</span><Input value={code} onChange={(e) => setCode(e.target.value)} placeholder="T1" className="w-24" data-testid="term-code" /></label>
          <label className="text-xs flex-1"><span className="text-[11px] uppercase tracking-widest text-slate-500 block mb-1">Name *</span><Input value={name} onChange={(e) => setName(e.target.value)} placeholder="Counter 1" data-testid="term-name" /></label>
          <Button onClick={add} className="bg-red-600 hover:bg-red-700" data-testid="term-add"><Plus className="h-4 w-4 mr-1" />Add</Button>
        </div>
      </div>
      <div className="bg-white rounded-lg border border-slate-200 overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-slate-50"><tr className="text-left text-[11px] uppercase tracking-widest text-slate-500"><th className="px-3 py-2">Code</th><th className="px-3 py-2">Name</th><th className="px-3 py-2">Store</th><th className="px-3 py-2 w-24"></th></tr></thead>
          <tbody className="divide-y divide-slate-100">
            {rows.length === 0 && <tr><td colSpan={4} className="px-3 py-8 text-center text-slate-400">No terminals yet.</td></tr>}
            {rows.map((t) => (
              <tr key={t.id} data-testid={`term-row-${t.id}`}>
                <td className="px-3 py-2 font-mono text-xs">{t.code}</td>
                <td className="px-3 py-2">{t.name}</td>
                <td className="px-3 py-2 text-xs text-slate-500">{t.store_type}</td>
                <td className="px-3 py-2 text-right"><button onClick={() => remove(t)} className="text-red-500"><Trash2 className="h-4 w-4" /></button></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
